/*
 * Woolman Common JS
 */

// Initialize window.Woolman object
if (typeof window.Woolman == 'undefined') {
  window.Woolman = {};
}
Woolman.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

// -------
// Load components / libraries
Woolman.init = function () {
  Woolman.ModalsAndDrawers.init();
  Woolman.Header.init();
  Woolman.DetailsAccordions.init();

   // Attach theme editor listeners
   if (!Shopify || !Shopify.designMode) return;

  let lastSelection = {
    sectionId: undefined,
    blockId: undefined
  };

  // Load is called when something is changed within section settings
  document.addEventListener('shopify:section:load', (evt) => {
    const sectionId = 'shopify-section-' + evt.detail.sectionId
    if (sectionId === Woolman.Header.cache.section.id) {
      Woolman.ModalsAndDrawers.init();
      Woolman.Header.init();
    }

    if (document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.showModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('shopify:section:load sectionId', evt.detail.sectionId)
    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:block:select', (evt) => {
    const sectionId = 'shopify-section-' + evt.detail.sectionId
    const blocks = document.getElementById(sectionId).querySelectorAll('[data-shopify-editor-block]')
    const selectedBlock = [...blocks].find(x => JSON.parse(x.dataset.shopifyEditorBlock).id === evt.detail.blockId);
    if (sectionId === Woolman.Header.cache.section.id) {
      if (selectedBlock) {

        //console.error('selBlo', selectedBlock)

        // Check if we are on megamenu and if currently on mobile
        const targetHandle = selectedBlock.dataset.menuHandle;
        const megamenu = document.querySelector(`.header-shortlink[data-submenu-open="${targetHandle}"]`);
        const isMobile = window.innerWidth < 1024;

        /* console.log('---------- MEGAMENU ----------')
        console.log('targetHandle', targetHandle)
        console.log('megamenu', megamenu)
        console.log('isMobile', isMobile) */

        if (megamenu && !isMobile) {
          megamenu.click();
          return;
        } else {
          // Make sure drawer menu is open
          Woolman.Header.cache.openButton.click();
        }


        // Select menu item
        const accordion = selectedBlock.closest('[data-accordion-item]').querySelector('input');
        const label = selectedBlock.closest('[data-accordion-item]').querySelector('label');
        if (!accordion.checked) label.click();
      }
    } else if (sectionId.includes('modal') && document.getElementById(sectionId).querySelector('[data-modal]')) {
      if (selectedBlock) {
        Woolman.ModalsAndDrawers.showModalOrDrawer(document.getElementById(sectionId).querySelector('[data-modal]').id);
      }
    }

    lastSelection.sectionId = evt.detail.sectionId;
    lastSelection.blockId = evt.detail.blockId;
    console.log('shopify:block:select', evt.detail.sectionId, evt.detail.blockId)
    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:section:unload', (evt) => {
    console.log('shopify:section:unload sectionId', evt.detail.sectionId)
  })

  document.addEventListener('shopify:section:select', (evt) => {
    console.log('shopify:section:select', evt.detail.sectionId)
    lastSelection = {
      sectionId: evt.detail.sectionId,
      blockId: evt.detail.blockId
    }

    if (evt.detail.sectionId.includes('modal') && document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.showModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:section:deselect', (evt) => {
    console.log('shopify:section:deselect', evt.detail.sectionId)
    lastSelection = {
      sectionId: undefined,
      blockId: undefined
    }

    if (evt.detail.sectionId.includes('modal') && document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.closeModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('lastSelection', lastSelection)
  })
};

// -------
// Woolman Common JS - Utility library
Woolman.Utils = {
  debugMode: true,
  focusTraps: {},
  checkCanFocusTrap: (trapContainers) => {
    const results = trapContainers.map((trapContainer) => {
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          if (getComputedStyle(trapContainer).visibility !== 'hidden') {
            resolve();
            clearInterval(interval);
          }
        }, 5);
      });
    });
    // Return a promise that resolves when all the trap containers are able to receive focus
    return Promise.all(results);
  },
  onFocusTrapDeactivate: (targetElement) => {
    targetElement.classList.remove('focus-trap');
    document.body.classList.remove('focus-being-trapped');

    // Handle drawer dialog accessibility
    if (targetElement.classList.contains('drawer') && targetElement.hasAttribute('role')) {
      targetElement.setAttribute('aria-hidden', 'true');
      
      // Remove inert from all elements that were made inert when drawer opened
      document.querySelectorAll('[data-was-inert-by-drawer]').forEach(element => {
        element.removeAttribute('inert');
        element.removeAttribute('data-was-inert-by-drawer');
      });
    }
  },
  onFocusTrapActivate: (targetElement) => {
    targetElement.classList.add('focus-trap');
    document.body.classList.add('focus-being-trapped');

    // Handle drawer dialog accessibility
    if (targetElement.classList.contains('drawer') && targetElement.hasAttribute('role')) {
      targetElement.setAttribute('aria-hidden', 'false');
      
      // Make all siblings of the drawer inert to completely prevent focus escape
      // This is more comprehensive than targeting specific elements
      Array.from(document.body.children).forEach(child => {
        if (child !== targetElement && !child.contains(targetElement)) {
          child.setAttribute('inert', '');
          child.setAttribute('data-was-inert-by-drawer', 'true');
        }
      });
    }
  },
  clearFocusTrap: (cacheKey) => {
    if (Woolman.Utils.focusTraps[cacheKey]) {
      Woolman.Utils.focusTraps[cacheKey].deactivate();
      Woolman.Utils.focusTraps[cacheKey] = undefined;
    }
  },
  prepareQueryParams: () => {
    Shopify.queryParams = Shopify.queryParams || {};

    // Preserve existing query parameters
    if (location.search.length) {
      const params = location.search.substr(1).split('&');

      for (let i = 0; i < params.length; i++) {
        const keyValue = params[i].split('=');

        if (keyValue.length) {
          Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
        }
      }
    }

    return Shopify.queryParams;
  },
  formatMoney(cents, format) {
    const default_money_format = theme.settings.moneyFormat || '€{{amount}}';
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    if (window?.Shopify?.currency?.rate) {
      cents = cents * parseFloat(window.Shopify.currency.rate || 1.0);
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || default_money_format;

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  },
};

// -------
// Woolman Common JS - Header component
Woolman.Header = {
  selectors: {
    header: 'MainHeader',
    announcementBar: '.announcements-bar',
    cartBlip: '.cart-blip',
    cartAccessibility: '.cart-text'
  },
  cache: {
    header: undefined,
    cartBlip: undefined,
    section: undefined,
    openButton: undefined,
    cartAccessibility: undefined
  },
  focusTraps: {},

  init: function () {
    this.cache.header = document.getElementById(this.selectors.header);
    this.cache.cartBlip = this.cache?.header?.querySelector(this.selectors.cartBlip);
    this.cache.section = this.cache.header.closest('.shopify-section');
    this.cache.openButton = this.cache.header.querySelector('[href="#drawer-menu"]');
    this.cache.announcementBar = document.querySelector(this.selectors.announcementBar);
    this.cache.cartAccessibility = this.cache.header.querySelectorAll(this.selectors.cartAccessibility);

    // Update cart blip when product is added to cart.
    document.addEventListener('ajaxProduct:added', this.updateCartBlip.bind(this))
    document.addEventListener('cart:update', this.updateCartBlip.bind(this));

    this.announcementBarHeight = this.cache.announcementBar.offsetHeight || 0;
    if (this.cache.announcementBar.dataset.stickyBehavior === 'fixed') {
      this.cache.header.style.setProperty('--margin-top', this.announcementBarHeight + 'px');
    }

    if (this.cache.header.dataset.stickyBehavior === 'none') return;
    this.initStickyBehavior(this.cache.header.dataset.stickyBehavior)
  },

  initStickyBehavior(behaviorType) {
    const stickyConfig = {
      headerHeight: this.cache.header.clientHeight,
      behavior: behaviorType
    }

    document.documentElement.classList.add('sticky-header-initialized', `sticky-header-${behaviorType}`);
    document.documentElement.style.setProperty('--sticky-header-margin-top', `${stickyConfig.headerHeight + this.announcementBarHeight}px`);

    if (behaviorType === 'scroll' || behaviorType === 'fixed') {
      // Show on scroll fixed header
      let prevScroll = window.scrollY || document.documentElement.scrollTop;
      let curScroll;
      let direction = 0;
      let prevDirection = 0;

      /*
      ** Find the direction of scroll
      ** 0 - initial, 1 - up, 2 - down
      */

      const toggleStickyHeader = (direction, curScroll) => {
        if ((direction === 1) || curScroll < stickyConfig.headerHeight) {
          document.documentElement.classList.remove('sticky-header-hide')
        } else if (direction === 2 && curScroll > stickyConfig.headerHeight) {
          document.documentElement.classList.add('sticky-header-hide')

          // dispatch event to close all open megamenus when sticky header is hidden
          document.dispatchEvent(new CustomEvent('woolman:sticky-header-hide'));
        }

        prevDirection = direction;
      }

      window.addEventListener('scroll', throttle(() => {
        curScroll = window.scrollY || document.documentElement.scrollTop;

        if (curScroll >= 300) {
          document.documentElement.classList.add('sticky-header-show')
        } else {
          document.documentElement.classList.remove('sticky-header-show');
        }

        if (curScroll > prevScroll) {
          direction = 2; // user scrolling down
        } else {
          direction = 1; // user scrolling up
        }

        if (direction !== prevDirection && behaviorType === 'scroll') {
          toggleStickyHeader(direction, curScroll)
        }

        prevScroll = curScroll
      }, 50))

      setInterval(() => {
        if (direction === 2 && behaviorType === 'scroll' && curScroll >= 900) {
          toggleStickyHeader(direction, curScroll);
        }
        if (window.scrollY === 0) {
          document.documentElement.classList.remove('sticky-header-show', 'sticky-header-hide');
        }
      }, 200)
    }
  },

  async updateCartBlip(e) {
    const cart = e.detail && e.detail.cart && e.detail.cart.item_count || await (async function () {
      const res = await fetch('/cart.json');
      const cart = await res.json();
      return cart;
    })();

    this.cache.cartBlip.textContent = cart.item_count || 0;
    this.cache.cartAccessibility.forEach((el) => {
      const cartText = el.textContent;
      // Find and replace only the number in parentheses with the new item count
      el.textContent = cartText.replace(/\(\d+\)/, `(${cart.item_count || 0})`);
    });

    // Update the aria-label of the cart button
    const cartButton = this.cache.cartBlip.closest('.header-item__link');
    if (cartButton) {
      const itemCount = cart.item_count || 0;
      let ariaLabel;
      if (itemCount === 0) {
        // Use empty cart translation
        ariaLabel = window.accessibilityStrings?.cart?.button_label_empty;
      } else {
        // Use regular cart translation with item count
        const ariaLabelTemplate = window.accessibilityStrings?.cart?.button_label;
        ariaLabel = ariaLabelTemplate.replace('{{ count }}', itemCount);
      }
      cartButton.setAttribute('aria-label', ariaLabel);
    }

    if (cart && cart.item_count == 0) {
      this.cache.cartBlip.setAttribute('hidden', true);
      this.cache.cartBlip.closest('.header-item__link').classList.remove('has-blip-visible');
    } else {
      this.cache.cartBlip.removeAttribute('hidden')
      this.cache.cartBlip.closest('.header-item__link').classList.add('has-blip-visible');
    }
  }
};

// -------
// Woolman Common JS - Modals & drawers library
Woolman.ModalsAndDrawers = {
  settings: {
    selectors: {
      modalLink: 'a[href*="modal"]:not(.quick-buy_link)',
      drawerLink: 'a[href*="drawer"]',
    },
  },
  focusTraps: {},
  init: function () {
    // Init open event listeners
    document.querySelectorAll(this.settings.selectors.modalLink).forEach((modalLink) => {
      /* Check if a modal should be opened by default when the page loads */
      const targetId = modalLink.getAttribute('href').substring(1).split('?')[0]
      const targetElement = document.getElementById(targetId);

      if (targetElement && targetElement.id === window.location.hash.substring(1)) {
        this.showModalOrDrawer(targetId);
        window.location.hash = '';
      }

      modalLink.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href').substring(1).split('?')[0];
        const pageId = event.currentTarget.getAttribute('href').substring(1).split('?page=')[1];
        this.showModalOrDrawer(targetId, parseInt(pageId));
      });
    });

    document.querySelectorAll(this.settings.selectors.drawerLink).forEach((drawerLink) => {
      drawerLink.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href').substring(1).split('?')[0];
        const pageId = event.currentTarget.getAttribute('href').substring(1).split('?page=')[1];
        this.showModalOrDrawer(targetId, parseInt(pageId));
      });
    });

    // Init close event listeners
    const closeBtns = document.querySelectorAll('[data-close]');
    if (closeBtns) {
      closeBtns.forEach((closeBtn) => {
        closeBtn.addEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
      });
    }

    const overlays = document.querySelectorAll('[data-overlay]');
    if (overlays) {
      overlays.forEach((overlay) => {
        overlay.addEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
      });
    }
  },
  /**
   *
   * @param {string} targetId - ID of modal or drawer element, e.g. modal-geo, drawer-menu
   * @param {int} pageId - ID of page to load in modal or drawer, e.g. 1, 2, 3 (for multi-modal)
   * Traps focus to modal and disables body scrolling.
   * Focus trap utilizes focus-trap library: https://github.com/focus-trap/focus-trap
   */
  showModalOrDrawer: function (targetId, pageId) {
    const targetElement = document.getElementById(targetId);
    if (!targetElement && Woolman.Utils.debugMode) {
      console.warn('No modal/drawer element specified');
    }
    if (!targetElement) {
      return;
    }

    if (targetElement.classList.contains('is-open')) return;

    targetElement.classList.add('initialized', 'is-open');
    const isMultiModal = targetElement.nodeName === 'MODAL-GRIDY-SLIDER-PARENT';

    if (!Woolman.Utils.focusTraps[targetId]) {
      // Get the proper trap target - for cart drawer it's the form, for others it's usually the element with data-contents-wrapper or data-contents
      const trapTarget = targetElement.querySelector('[data-contents-wrapper]') || targetElement.querySelector('[data-contents]') || targetElement;

      // For drawer dialogs, set initial focus to the close button (for navigation drawer)
      let initialFocusElement = null;
      if (targetElement.classList.contains('drawer') && targetElement.hasAttribute('role') && targetId === 'drawer-menu') {
        // Focus the close button - it has aria-describedby to announce dialog context
        initialFocusElement = targetElement.querySelector('#drawer-menu-close, [data-close]');
      }

      // For cart drawer, set initial focus to the cart title or first focusable element
      if (targetElement.classList.contains('drawer') && targetId === 'drawer-cart') {
        initialFocusElement = targetElement.querySelector('#drawer-cart-title, h2, .drawer-title, [tabindex="-1"]')
      }

      // For filter drawer, set initial focus to the content wrapper to avoid focus lock on close button in Firefox
      if (targetElement.classList.contains('drawer') && targetId === 'drawer-filter') {
        initialFocusElement = targetElement.querySelector('#facets-mobi')
      }

      // For pickup availability drawer, set initial focus to the close button
      if (targetElement.classList.contains('drawer') && targetId === 'drawer-pickup-availability') {
        initialFocusElement = targetElement.querySelector('[data-close]');
      }

      const focusTrapConfig = {
        clickOutsideDeactivates: isMultiModal ? false : true,
        allowOutsideClick: isMultiModal ? true : false,
        escapeDeactivates: true,
        fallbackFocus: trapTarget,
        returnFocusOnDeactivate: true,
        preventScroll: true,
        delayInitialFocus: false,
        tabbableOptions: {
          displayCheck: 'none', // Firefox fix: don't check display/visibility
          getShadowRoot: true,
        },
      };

      // For pickup availability drawer, ensure proper focus cycling
      if (targetId === 'drawer-pickup-availability') {
        focusTrapConfig.setReturnFocus = true;
        // Ensure focus cycles properly in both directions
        focusTrapConfig.initialFocus = initialFocusElement;
      }

      // Only add initialFocus if we have an element to focus on
      if (initialFocusElement) {
        focusTrapConfig.initialFocus = initialFocusElement;
      } else if (targetId === 'drawer-cart') {
        // For cart drawer, if no specific title found, focus the first button or close button
        const fallbackElement = targetElement.querySelector('[data-close], button, a[href]');
        if (fallbackElement) {
          focusTrapConfig.initialFocus = fallbackElement;
        }
      }

      Woolman.Utils.focusTraps[targetId] = focusTrap.createFocusTrap(trapTarget, {
        ...focusTrapConfig,

        // Called before focus is sent
        onActivate: () => {
          Woolman.Utils.onFocusTrapActivate(targetElement);

          // Announce drawer opening for screen readers
          if (targetId === 'drawer-filter') {
            const announcement = targetElement.querySelector('[data-drawer-announcement]');
            const title = targetElement.querySelector('#drawer-filter-title');
            if (announcement && title) {
              announcement.textContent = `${title.textContent} opened`;
            }
          }

          // Dispatch open event for other parts of the code to listen to
          document.dispatchEvent(new CustomEvent(`drawerOrModalOpen.${targetId}`));

          setTimeout(() => {
            // check targetElement node name to determine if it's a modal or drawer
            if (pageId && isMultiModal) {
              const gridySlider = targetElement.querySelector('gridy-slider');
              gridySlider.scrollToSlide(pageId - 1);
            }
          }, 250)

          bodyScrollLock.disableBodyScroll(targetElement);
        },

        // There is a delay between when the class is applied
        // and when the element is focusable
        checkCanFocusTrap: Woolman.Utils.checkCanFocusTrap,

        // Called after focus is deactivated
        onDeactivate: () => {
          bodyScrollLock.enableBodyScroll(targetElement);
          Woolman.Utils.onFocusTrapDeactivate(targetElement);
          if (targetElement.classList.contains('is-open')) {
            targetElement.classList.remove('is-open');
          }

          document.dispatchEvent(new CustomEvent(`drawerOrModalClose.${targetId}`));
        },
      });
    }

    Woolman.Utils.focusTraps[targetId].activate();
  },
  /**
   *
   * @param {string} targetId - ID of target element, e.g. modal-geo, drawer-menu
   * Removes trapped focus when modal is closed by e.g. using the close button.
   */
  closeModalOrDrawer: function (targetId) {
    if (Woolman.Utils.focusTraps[targetId]) {
      Woolman.Utils.focusTraps[targetId].deactivate();
      Woolman.Utils.focusTraps[targetId] = undefined;
    }
  },
  closeModalOrDrawerOrDrawerFromEvent: function (event) {
    event.preventDefault();
    const parentElement = event.currentTarget.closest('[data-parent]');
    const targetId = parentElement.getAttribute('id');
    parentElement.classList.remove('is-open');
    Woolman.ModalsAndDrawers.closeModalOrDrawer(targetId);
  },
};

/**
 * Animated details element
 */
class Accordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('.content');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;

    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-in-out'
    });

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }
};

Woolman.DetailsAccordions = {
  init: function () {
    document.querySelectorAll('details').forEach((el) => {
      new Accordion(el);
    });
  }
};

Woolman.init();

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, wait) {
  let t = false;
  return (...args) => {
    if (!t) {
      fn.apply(this, args)
      t = true;
      setTimeout(() => t = false, wait)
    }
  }
}

/**
 * Allow us to trigger something when window is actually resized.
 */
let woolman_window_size = window.innerWidth;
window.addEventListener(
  'resize',
  debounce(() => {
    if (window.innerWidth == woolman_window_size) {
      return;
    }
    woolman_window_size = window.innerWidth;
    document.dispatchEvent(new CustomEvent('woolman:resize'));
  }),
  250
);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure__list-wrapper'),
    };

    if (this.elements.button) {
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    }

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);

// Custom element that enhances HTML Video Element functionality.
// Usage: <video is="superpowered-video">
class SuperPoweredVideo extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector('video') || this.querySelector('iframe');
    this.container = this.closest('.video-container') || null;

    if (this.container) this.attachClickListener(this.closest('.video-container'));

    // check if video is iframe and has a src and that src is youtube
    if (this.video.nodeName === 'IFRAME' && this.video.src && this.video.src.includes('youtube') && !this.container) {
      this.video.addEventListener('load', this.onVideoLoad.bind(this));
    }

    if (this.video.nodeName === 'VIDEO') {
      this.video.addEventListener('loadedmetadata', this.onVideoMetadataLoad.bind(this));
    }

    // When video is out of viewport pause it. This is to prevent videos from playing in the background.
    // If video is in viewport play it.
    // Use: Intersection Observer API
    const autoplay = this.dataset.autoplay || false;
    if (!autoplay || this.container) return;

    const videoType = this.video.nodeName === 'VIDEO' ? 'video' : 'iframe';
    const videoHost = this.video.nodeName === 'VIDEO' ? 'shopify' : (this.video.src.includes('youtube') ? 'youtube' : 'vimeo');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (videoType == 'video') {
            this.video.play();
          } else if (videoHost == 'youtube') {
            this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          } else if (videoHost == 'vimeo') {
            this.video.contentWindow.postMessage('{"method":"play"}', '*');
          }
        } else {
          if (videoType == 'video') {
            this.video.pause()
          } else if (videoHost == 'youtube') {
            this.video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          } else if (videoHost == 'vimeo') {
            this.video.contentWindow.postMessage('{"method":"pause"}', '*');
          }
        }
      });
    } , { threshold: 0.5 });

    observer.observe(this.video);
  }

  attachClickListener(videoContainer) {
    if (!videoContainer) return;
    videoContainer.addEventListener('click', (e) => {
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    });

    const playButton = videoContainer.querySelector('button');

    if (playButton) {
      this.video.onplay = () => {
        playButton.hidden = true;
      }

      this.video.onpause = () => {
        playButton.hidden = false;
      }
    }
  }

  onVideoLoad() {
    // force youtube to play on mobile
    this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  }

  onVideoMetadataLoad(e) {
    console.log('onVideoMetadataLoad', e)
    this.video.currentTime = 0; // This might help in forcing the display of the first frame for safari
  }
}
customElements.define('superpowered-video', SuperPoweredVideo);

// Gridy Slider - a custom Woolman built slider.
// Usage: <gridy-slider>
class GridySlider extends HTMLElement {
  constructor() {
    super();

    this.track = this.querySelector('.gridy-track');
    this.slides = this.querySelectorAll('.gridy-track > *');
    const child_count = this.track?.childElementCount || 0;

    // ACCESSIBILITY: Prevent scrollable track from receiving focus
    // Scrollable containers are naturally focusable; we want focus to go
    // directly to the navigation buttons and visible slide content
    if (this.track) {
      this.track.setAttribute('tabindex', '-1');
    }

    const data_ipr_desktop = parseInt(this.dataset.iprDesktop, 10) || 1;
    const data_ipr_tablet = parseInt(this.dataset.iprTablet, 10) || data_ipr_desktop;
    const data_ipr_mobile = parseInt(this.dataset.iprMobile, 10) || 1;
    const data_init_scroll_to = this.dataset.initScrollTo;
    const data_autoplay = this.dataset.autoplay != undefined ? JSON.parse(this.dataset.autoplay) : false;
    const data_autoplay_delay = parseInt(this.dataset.autoplayDelay, 10) || 5000;
    const data_is_thumbnails_slider = this.dataset.thumbnailsFor != undefined ? true : false;
    const data_indicator = this.dataset.indicator != undefined ? JSON.parse(this.dataset.indicator) : false;
    const thumbnail_slider = document.getElementById(`thumbnail-${this.id}`);
    const data_mobile_enabled = this.dataset.mobileEnabled != undefined ? JSON.parse(this.dataset.mobileEnabled) : true;
    const data_tablet_enabled = this.dataset.tabletEnabled != undefined ? JSON.parse(this.dataset.tabletEnabled) : true;
    const data_desktop_enabled = this.dataset.desktopEnabled != undefined ? JSON.parse(this.dataset.desktopEnabled) : true;

    this.config = {
      slide_count: child_count,
      current_slide: 0,
      active_slide_offset: 0, // used for thubnails slider

      ipr_desktop: data_ipr_desktop,
      ipr_tablet: data_ipr_tablet,
      ipr_mobile: data_ipr_mobile,
      breakpoint_tablet: 768,
      breakpoint_desktop: 1024,

      mobile_enabled: data_mobile_enabled,
      tablet_enabled: data_tablet_enabled,
      desktop_enabled: data_desktop_enabled,

      arrows: true,
      autoplay: data_autoplay || false,
      autoplay_delay: data_autoplay_delay, // in ms
      timer: null,

      // thumbnails related
      is_thumbnails_slider: data_is_thumbnails_slider,
      thumbnails_for: undefined,
      thumbnail_slider: thumbnail_slider,

      indicator: data_indicator
    }

    // SCROLL ON INIT (with variant URL)
    if (data_init_scroll_to != undefined) {
      this.scrollToSlideByID(data_init_scroll_to);
    }

    // ARROWS INIT
    if (this.config.arrows) {
      this.buttons = this.querySelectorAll('[data-gridy-arrow]');
      this.buttons.forEach((arrowButton) => {
        arrowButton.addEventListener('click', this.onArrowClick.bind(this));

        // ACCESSIBILITY: Add keyboard support
        arrowButton.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.onArrowClick(e);
          }
        });
      });

      // ACCESSIBILITY: Update button states initially
      this.updateButtonStates();
    }

    // AUTOPLAY INIT
    if (this.config.autoplay) {
      this.autoplayGridy();

      // Always pause on hover
      this.addEventListener('mouseenter', this.clearAutoplayTimer);
      this.addEventListener('mouseleave', this.autoplayGridy);

      // Pause for touch devices
      this.addEventListener('touchenter', this.clearAutoplayTimer);
      this.addEventListener('touchleave', this.autoplayGridy);
    }

    // THUMBNAILS INIT
    if (this.config.is_thumbnails_slider) {
      this.config.active_slide_offset =  2,
      this.config.thumbnails_for = document.getElementById(this.dataset.thumbnailsFor);
      this.thumbnail = this.querySelectorAll('[data-thumbnail-btn]');
      this.thumbnail.forEach((thumbnail) => {
        thumbnail.addEventListener('click', this.onThumbnailClick.bind(this));
      });
    }

    // CURRENT SLIDE INDICATORS INIT
    if (this.config.indicator) {
      this.indicator_dots = this.querySelectorAll('[data-indicator-dot]');
      this.indicator_current = this.querySelector('[data-indicator-current]');
    }

    // SCROLL LISTENER (for setting active slide after normal scroll)
    if (!this.config.is_thumbnails_slider) {
      let scrollTimeout;
      this.track.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(this.afterScrollStops.bind(this), 200);
      }.bind(this));
    }

    // ACCESSIBILITY: Initialize slide visibility for focus management
    // Use setTimeout to ensure DOM is fully rendered before checking visibility
    setTimeout(() => {
      this.updateSlideAccessibility();
    }, 0);

    // ACCESSIBILITY: Update on window resize (items per row may change)
    document.addEventListener('woolman:resize', () => {
      this.updateSlideAccessibility();
      this.updateButtonStates();
    });
  }

  afterScrollStops() {
    let slideInView = this.firstSlideInView();
    this.config.current_slide = slideInView;
    this.setActiveSlide(this.slides[slideInView + this.config.active_slide_offset]);

    // ACCESSIBILITY: Update which slides are focusable after scroll
    this.updateSlideAccessibility();

    // SYNC BACK TO THUMBNAILS SLIDER
    if (this.config.thumbnail_slider) {
      this.config.thumbnail_slider.scrollToSlide(slideInView);
    }
  }

  autoplayGridy() {
    this.config.timer = setInterval(() => this.scrollByIPR('next', true), this.config.autoplay_delay); // true = announce for accessibility
  }

  clearAutoplayTimer() {
    clearInterval(this.config.timer);
    this.config.timer = null;
  }

  onThumbnailClick(event) {
    event.preventDefault();
    this.config.current_slide = Array.from(event.currentTarget.parentNode.children).indexOf(event.currentTarget);
    this.config.thumbnails_for.scrollToSlideByID(event.currentTarget.dataset.itemId);
    this.scrollToSlide(this.config.current_slide);
  }

  onArrowClick(event) {
    this.scrollByIPR(event.currentTarget.dataset.direction, true); // true = should announce
  }

  scrollByIPR(direction, shouldAnnounce = false) {
    // Don't navigate if slider is disabled for current viewport
    if (!this.isSliderEnabled()) return;
    
    let slideMultiplier = this.getCurrentSlideMultiplier(),
        slideInView = this.firstSlideInView(),
        newCurrentSlide = slideInView;

    if (direction === 'next') {
      newCurrentSlide = (newCurrentSlide + slideMultiplier);
    } else if (direction === 'prev') {
      newCurrentSlide = (newCurrentSlide - slideMultiplier);
    }

    if ((newCurrentSlide + 1 ) > this.config.slide_count || slideInView > 0 && newCurrentSlide < 0) {
      newCurrentSlide = 0;
    } else if (newCurrentSlide < 0) {
      newCurrentSlide = this.config.slide_count - slideMultiplier;
    }

    this.scrollToSlide(newCurrentSlide, shouldAnnounce);
  }

  scrollToSlide(newPosition, shouldAnnounce = false) {
    // Needs to use scrollTo() instead of scrollIntoView()
    // since the later affects window scroll and thus cannot
    // be used with autoplay sliders.

    if (isNaN(newPosition)) {
      return;
    }

    // Can show different active slide compared to scrollTo slide for example in thumbnails slider
    let slidePosWithOffset = newPosition - this.config.active_slide_offset,
        newScrollToSlidePos = slidePosWithOffset > 0 ? slidePosWithOffset : 0;

    const slideInNewScrollToPos = this.slides[newScrollToSlidePos];

    this.track.scrollTo({
      left: slideInNewScrollToPos.offsetLeft,
      top: slideInNewScrollToPos.offsetTop,
      behavior: "smooth",
    });

    // Announce slide change for accessibility if this is manual navigation
    if (shouldAnnounce) {
      const slideMultiplier = this.getCurrentSlideMultiplier();
      const firstVisible = newPosition + 1;
      const lastVisible = Math.min(newPosition + slideMultiplier, this.config.slide_count);
      this.announceSlideChange(firstVisible, lastVisible, this.config.slide_count);
    }

    this.slides.forEach((item) => { 
      item.classList.remove('active');
      // Update aria-pressed for thumbnail buttons
      const btn = item.querySelector('[data-thumbnail-btn]');
      if (btn) {
        btn.setAttribute('aria-pressed', 'false');
        // Update aria-label to remove "selected" state
        const currentLabel = btn.getAttribute('aria-label') || '';
        btn.setAttribute('aria-label', currentLabel.replace(/, selected$/, ''));
      }
    });
    this.slides[newPosition].classList.add('active');
    // Update aria-pressed for newly active thumbnail
    const activeBtn = this.slides[newPosition].querySelector('[data-thumbnail-btn]');
    if (activeBtn) {
      activeBtn.setAttribute('aria-pressed', 'true');
      // Update aria-label to add "selected" state
      const currentLabel = activeBtn.getAttribute('aria-label') || '';
      if (!currentLabel.endsWith(', selected')) {
        activeBtn.setAttribute('aria-label', currentLabel + ', selected');
      }
    }

    // ACCESSIBILITY: Update which slides are focusable after navigation
    // Update current_slide to match the new position
    this.config.current_slide = newPosition;
    // Use setTimeout to allow smooth scroll to complete before updating
    setTimeout(() => this.updateSlideAccessibility(), 50);
  }

  scrollToSlideByID(slideID) {
    // Second scrollTo method used with slideID
    // Used through thumbnails and variant change events

    const theSlide = document.getElementById(slideID),
          newPosition = Array.from(theSlide.parentNode.children).indexOf(theSlide);

    this.scrollToSlide(newPosition, false); // Don't announce for programmatic navigation
  }

  setActiveSlide(slide) {
    this.slides.forEach((item) => { item.classList.remove('active') });
    slide.classList.add('active');

    if (this.config.indicator) {
      this.indicator_current.textContent = this.config.current_slide + 1;
      this.indicator_dots.forEach((dot) => { dot.classList.remove('active') });
      this.indicator_dots[this.config.current_slide].classList.add('active');
    }

    // ACCESSIBILITY: Update button states after slide change
    this.updateButtonStates();
  }

  // ACCESSIBILITY: Update button states
  updateButtonStates() {
    if (!this.buttons || !this.config.arrows) return;

    // If slider is disabled for current viewport, hide navigation buttons
    const sliderEnabled = this.isSliderEnabled();
    
    const slideMultiplier = this.getCurrentSlideMultiplier();
    const maxPosition = Math.max(0, this.config.slide_count - slideMultiplier);
    
    // If all slides fit in viewport OR slider is disabled, disable both buttons
    const allSlidesVisible = slideMultiplier >= this.config.slide_count;
    const shouldDisableButtons = !sliderEnabled || allSlidesVisible;

    this.buttons.forEach((button) => {
      const direction = button.dataset.direction;
      let isDisabled = false;

      if (shouldDisableButtons) {
        // Slider disabled or all slides visible - no navigation needed
        isDisabled = true;
      } else if (direction === 'prev') {
        isDisabled = this.config.current_slide === 0;
      } else if (direction === 'next') {
        isDisabled = this.config.current_slide >= maxPosition;
      }

      button.setAttribute('aria-disabled', isDisabled.toString());
      button.disabled = isDisabled;
      
      // Remove disabled buttons from tab order to prevent focus order issues
      if (isDisabled) {
        button.setAttribute('tabindex', '-1');
      } else {
        button.removeAttribute('tabindex');
      }
    });
  }

  // ACCESSIBILITY: Update tabindex on slides based on visibility
  // Only visible slides should be focusable to match visual layout
  // Exception: Thumbnail sliders should keep all items keyboard accessible
  updateSlideAccessibility() {
    // Skip for thumbnail sliders - all thumbnails should remain keyboard accessible
    if (this.config.is_thumbnails_slider) return;

    // If slider is disabled for current viewport, keep all items keyboard accessible
    // (functions as a regular grid, not a carousel)
    if (!this.isSliderEnabled()) {
      this.slides.forEach((slide) => {
        slide.setAttribute('aria-hidden', 'false');
        const focusableElements = slide.querySelectorAll(
          'a[href], button, input, select, textarea, [tabindex]'
        );
        focusableElements.forEach(element => {
          if (element.hasAttribute('data-gridy-arrow')) return;
          if (element.getAttribute('aria-hidden') === 'true') return;
          // Restore original tabindex if we previously modified it
          if (element.hasAttribute('data-original-tabindex')) {
            const originalValue = element.getAttribute('data-original-tabindex');
            if (originalValue === 'none') {
              element.removeAttribute('tabindex');
            } else {
              element.setAttribute('tabindex', originalValue);
            }
            element.removeAttribute('data-original-tabindex');
          }
        });
      });
      return;
    }

    const slideMultiplier = this.getCurrentSlideMultiplier();
    
    // If all slides fit in the viewport, don't hide any - all should be keyboard accessible
    if (slideMultiplier >= this.config.slide_count) {
      this.slides.forEach((slide) => {
        slide.setAttribute('aria-hidden', 'false');
        const focusableElements = slide.querySelectorAll(
          'a[href], button, input, select, textarea, [tabindex]'
        );
        focusableElements.forEach(element => {
          if (element.hasAttribute('data-gridy-arrow')) return;
          if (element.getAttribute('aria-hidden') === 'true') return;
          // Restore original tabindex if we previously modified it
          if (element.hasAttribute('data-original-tabindex')) {
            const originalValue = element.getAttribute('data-original-tabindex');
            if (originalValue === 'none') {
              element.removeAttribute('tabindex');
            } else {
              element.setAttribute('tabindex', originalValue);
            }
            element.removeAttribute('data-original-tabindex');
          }
        });
      });
      return;
    }

    // Use current_slide for reliable tracking of which slides should be accessible
    // current_slide is updated by scrollToSlide() and afterScrollStops()
    const firstVisibleIndex = this.config.current_slide;
    const lastVisibleIndex = Math.min(firstVisibleIndex + slideMultiplier - 1, this.config.slide_count - 1);

    this.slides.forEach((slide, index) => {
      const isVisible = index >= firstVisibleIndex && index <= lastVisibleIndex;
      
      // Select ALL naturally focusable elements
      const focusableElements = slide.querySelectorAll(
        'a[href], button, input, select, textarea, [tabindex]'
      );
      
      focusableElements.forEach(element => {
        // Skip navigation arrows - they're outside the slide content flow
        if (element.hasAttribute('data-gridy-arrow')) return;
        
        // Skip elements that are intentionally hidden (e.g., visually-hidden skip links)
        if (element.getAttribute('aria-hidden') === 'true') return;
        
        if (isVisible) {
          // Restore original tabindex if we previously modified it
          if (element.hasAttribute('data-original-tabindex')) {
            const originalValue = element.getAttribute('data-original-tabindex');
            if (originalValue === 'none') {
              element.removeAttribute('tabindex');
            } else {
              element.setAttribute('tabindex', originalValue);
            }
            element.removeAttribute('data-original-tabindex');
          }
        } else {
          // Store original tabindex before hiding (only if not already stored)
          if (!element.hasAttribute('data-original-tabindex')) {
            const currentTabindex = element.getAttribute('tabindex');
            element.setAttribute('data-original-tabindex', currentTabindex === null ? 'none' : currentTabindex);
          }
          // Hide from tab order
          element.setAttribute('tabindex', '-1');
        }
      });

      // Set aria-hidden on non-visible slides
      slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    });
  }

  getCurrentSlideMultiplier() {
    let currentSlideMultiplier = this.config.ipr_mobile;
    if (woolman_window_size >= this.config.breakpoint_desktop) {
      currentSlideMultiplier = this.config.ipr_desktop;
    } else if (woolman_window_size >= this.config.breakpoint_tablet) {
      currentSlideMultiplier = this.config.ipr_tablet;
    }
    return currentSlideMultiplier;
  }

  // Check if slider mode is enabled for current viewport
  isSliderEnabled() {
    if (woolman_window_size >= this.config.breakpoint_desktop) {
      return this.config.desktop_enabled;
    } else if (woolman_window_size >= this.config.breakpoint_tablet) {
      return this.config.tablet_enabled;
    }
    return this.config.mobile_enabled;
  }

  // Utility, returns the position of the first slide in view (1..n)
  firstSlideInView() {
    let loopIndex = 0;
    for (const slide of this.slides) {
      if (this.isSlideInView(slide)) {
        return loopIndex;
      }
      ++loopIndex;
    }

    // If visibility check fails return the last known current_slide
    return this.config.current_slide;
  }

  // Helper, element visibility check
  isSlideInView(slide) {
    const containerBounds = this.track.getBoundingClientRect();
    const slideBounds = slide.getBoundingClientRect();

    const isSlideVisible =
    Math.round(slideBounds.top) >= Math.round(containerBounds.top) &&
    Math.round(slideBounds.bottom) <= Math.round(containerBounds.bottom) &&
    Math.round(slideBounds.left) >= Math.round(containerBounds.left) &&
    Math.round(slideBounds.right) <= Math.round(containerBounds.right);

    return isSlideVisible;
  }

  // Announce slide changes to screen readers via live region
  announceSlideChange(firstVisible, lastVisible, totalSlides) {
    const liveRegion = document.getElementById(`carousel-status-${this.id.replace('slider-', '')}`);
    if (!liveRegion) return;
    
    // Clear any pending timeout to prevent race conditions with rapid clicks
    if (this.announceTimeout) {
      clearTimeout(this.announceTimeout);
    }
    
    // Ensure totalSlides is valid - fallback to slide_count if undefined
    const total = totalSlides || this.config.slide_count || 0;
    
    // Determine if we're showing a single item or a range
    const isSingleItem = firstVisible === lastVisible;
    
    // Format: "Item 5 of 12" or "Items 3-4 of 12"
    let announcement;
    if (this.dataset.slideAnnouncement) {
      // Check if template includes [LAST] placeholder for range support
      const hasRangePlaceholder = this.dataset.slideAnnouncement.includes('[LAST]');
      
      if (!isSingleItem && !hasRangePlaceholder) {
        // Template doesn't support ranges, but we're showing multiple items
        // Build a proper range announcement
        const template = this.dataset.slideAnnouncement;
        // Replace "Slide" with "Slides" or "Item" with "Items" for plural
        const pluralTemplate = template
          .replace(/\bSlide\b/g, 'Slides')
          .replace(/\bItem\b/g, 'Items');
        announcement = pluralTemplate
          .replace('[FIRST]', `${firstVisible}-${lastVisible}`)
          .replace('[TOTAL]', total);
      } else {
        // Use the template as-is with placeholder replacement
        announcement = this.dataset.slideAnnouncement
          .replace('[FIRST]', firstVisible)
          .replace('[LAST]', lastVisible)
          .replace('[TOTAL]', total);
        
        // Fix "Items/Slides X-X" to "Item/Slide X" for single items (handles any word)
        if (isSingleItem) {
          announcement = announcement.replace(/\b(Item|Slide)s\s+(\d+)-\2\b/g, '$1 $2');
        }
      }
    } else {
      // Use default formatting
      announcement = isSingleItem 
        ? `Item ${firstVisible} of ${total}`
        : `Items ${firstVisible}-${lastVisible} of ${total}`;
    }
    
    // Clear the content first to ensure screen reader re-reads even if same text
    liveRegion.textContent = '';
    
    // Use requestAnimationFrame to ensure the clear is processed before setting new content
    requestAnimationFrame(() => {
      // Set the announcement content
      // Note: Never toggle aria-hidden on live regions - it interferes with announcements
      liveRegion.textContent = announcement;
      
      // Clear the content after enough time for screen readers to process
      // This prevents the message from being focusable in browse mode (arrows/swiping)
      // Increased to 3000ms to ensure reliable announcements, especially with NVDA + zoom
      this.announceTimeout = setTimeout(() => {
        liveRegion.textContent = '';
      }, 3000);
    });
  }
}
customElements.define('gridy-slider', GridySlider);


/* accessibility handle tabindex for dynamically added upsell cards*/
function removeUpsellTabindex() {
  document.querySelectorAll('.upsell-card-title, .upsell_form_submit').forEach(function(el) {
    el.removeAttribute('tabindex');
    if (el.disabled) {
      el.removeAttribute('disabled');
    }
  });
  document.querySelectorAll('.upsell-card-media').forEach(function(el) {
    el.setAttribute('tabindex', '-1');
    if (el.disabled) {
      el.setAttribute('tabindex', '-1');
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(removeUpsellTabindex, 100);

  // Observe for dynamically added elements
  const observer = new MutationObserver(removeUpsellTabindex);
  observer.observe(document.body, { childList: true, subtree: true });
});